import PropTypes from 'prop-types'
import { rightLevelPropType } from './right-level-prop-type'

/**
 * Represents a profile in Webfleet that can be applied to a user which covers one or more right levels. With those
 * right levels the user enjoys specific functionality in Webfleet.
 * WASAPI type.
 *
 * @typedef {Object} RightProfile
 * @property {string} [profileId]
 * @property {string} [name]
 * @property {string} [stringCode]
 * @property {boolean} [available]
 * @property {number} [orderKey]
 * @property {RightLevel[]} [availableRightLevels]
 * @property {RightLevel[]} [defaultRightLevels]
 */

export const rightProfilePropType = PropTypes.shape({
    available: PropTypes.bool,
    availableRightLevels: PropTypes.arrayOf(rightLevelPropType),
    defaultRightLevels: PropTypes.arrayOf(rightLevelPropType),
    name: PropTypes.string,
    orderKey: PropTypes.number,
    profileId: PropTypes.string,
    stringCode: PropTypes.string
})
